/**
 * ARIA brand logo — gradient badge with a stylized "A" whose crossbar is a
 * pulse/heartbeat trace, framed by subtle viewfinder brackets (imaging).
 * Same artwork as /public/favicon.svg to keep brand identity consistent.
 */
export const AriaLogo = ({ size = 36, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="ARIA logo"
    className={className}
    {...props}
  >
    <defs>
      <linearGradient id="ariaLogoGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#22d3ee" />
        <stop offset="1" stopColor="#0d9488" />
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="116" height="116" rx="28" fill="url(#ariaLogoGrad)" />
    <g stroke="#0a161a" strokeWidth="6" strokeLinecap="round" fill="none" opacity="0.32">
      <path d="M 24 40 L 24 30 Q 24 24 30 24 L 40 24" />
      <path d="M 104 40 L 104 30 Q 104 24 98 24 L 88 24" />
      <path d="M 24 88 L 24 98 Q 24 104 30 104 L 40 104" />
      <path d="M 104 88 L 104 98 Q 104 104 98 104 L 88 104" />
    </g>
    <g stroke="#0a161a" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M 40 96 L 64 32 L 88 96" strokeWidth="11" />
      <path d="M 47 76 L 54 76 L 59 67 L 66 83 L 71 76 L 81 76" strokeWidth="8" />
    </g>
  </svg>
);

export default AriaLogo;
